import { getItems, postUserResourse } from "../../../api/repositories/userCourses";

export default {
  async get_userCourses({ commit }, { perPage, currentPage }) {
    try {
     
      const response = await getItems(perPage, currentPage);
      commit("SET_USERCOURSES", response);
    } catch (error) {
      
      // commit("SET_HANDLE_ESTATUS_ERROR", error);
    }
  },
  async post_user_resourse({ commit },{ _body }) {
    await postUserResourse(_body);
  },
};
